// extracted by mini-css-extract-plugin
var _1 = "AfterConfirmText_afterConfirmTextContainer__wj6ja";
var _2 = "768px";
var _3 = "'../../../shared.module.css'";
export { _1 as "afterConfirmTextContainer", _2 as "md", _3 as "shared" }
